import clsx from 'clsx';
import React, { ClassAttributes } from 'react';
import styles from './TableData.module.css';

export const TableData = ({
  className,
  ...props
}: JSX.IntrinsicAttributes &
  React.ClassAttributes<HTMLTableDataCellElement> &
  React.TdHTMLAttributes<HTMLTableDataCellElement>) => (
  <td className={clsx(styles.tableData, className)} {...props} />
);
